/**
 * Route for `network-api-integrations`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { NetworkApiIntegrationsPage } from "../features/network-api-integrations/NetworkApiIntegrationsPage";

export const networkApiIntegrationsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/network-api-integrations",
	component: NetworkApiIntegrationsPage,
});

export default networkApiIntegrationsRoute;
